import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

// 解决了问题：
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location: any): any {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index/Welcome'
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "CanteenManagement" */ '@/views/Login/Login.vue'),
    meta: {
      index: 1
    }
  },
  {
    path: '/index',
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "CanteenManagement" */ '@/views/Layout/Home.vue'),
    children: [
      {
        path: 'Welcome',
        name: 'Welcome',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/Welcome/Welcome.vue'),
        meta: {
          title: '',
          index: 2
        }
      },
      {
        path: 'OrganizationChart',
        name: 'OrganizationChart',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/BasicManagement/OrganizationChart.vue'),
        meta: {
          title: '基础管理-组织架构',
          index: 2
        }
      },
      {
        path: 'RoleJurisdiction',
        name: 'RoleJurisdiction',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/BasicManagement/RoleJurisdiction.vue'),
        meta: {
          title: '基础管理-角色权限管理',
          index: 2
        }
      },
      {
        path: 'RoleDistribution',
        name: 'RoleDistribution',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/BasicManagement/RoleDistribution.vue'),
        meta: {
          title: '基础管理-权限分配',
          index: 2
        }
      },
      {
        path: 'UserManagement',
        name: 'UserManagement',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/BasicManagement/UserManagement.vue'),
        meta: {
          title: '基础管理-用户管理',
          index: 2
        }
      },
      {
        path: 'AddOrUpdateUser',
        name: 'AddOrUpdateUser',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/BasicManagement/AddOrUpdateUser.vue'),
        meta: {
          title: '基础管理-用户管理',
          index: 2
        }
      },
      {
        path: 'EnumType',
        name: 'EnumType',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/BasicManagement/EnumType.vue'),
        meta: {
          title: '基础管理-枚举管理',
          index: 2
        }
      },
      {
        path: 'CanteenIndexConfig',
        name: 'CanteenIndexConfig',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenIndex/CanteenIndexConfig.vue'),
        meta: {
          title: '首页配置',
          index: 2
        }
      },
      {
        path: 'CanteenIndexConfigDetail',
        name: 'CanteenIndexConfigDetail',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenIndex/CanteenIndexConfigDetail.vue'),
        meta: {
          title: '首页-详情查看',
          index: 2
        }
      },
      {
        path: 'AddOrUpdateCanteenIndexConfig',
        name: 'AddOrUpdateCanteenIndexConfig',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenIndex/AddOrUpdateCanteenIndexConfig.vue'),
        meta: {
          title: '首页配置',
          index: 2
        }
      },
      {
        path: 'CanteenIndex',
        name: 'CanteenIndex',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenIndex/CanteenIndex.vue'),
        meta: {
          title: '首页',
          index: 2
        }
      },
      {
        path: 'CanteenSubject',
        name: 'CanteenSubject',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenSubject/CanteenSubject.vue'),
        meta: {
          title: '科目管理',
          index: 2
        }
      },
      // 食堂资金管理：学校端：
      {
        path: 'CapitalShiftToAffirm',
        name: 'CapitalShiftToAffirm',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/School/CapitalShiftToAffirm.vue'),
        meta: {
          title: '食堂资金管理-资金转出登记',
          index: 2
        }
      },
      {
        path: 'CapitalApplicationForUse',
        name: 'CapitalApplicationForUse',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/School/CapitalApplicationForUse.vue'),
        meta: {
          title: '食堂资金管理-资金使用申请',
          index: 2
        }
      },
      {
        path: 'CapitalApplicationForUseOfPending',
        name: 'CapitalApplicationForUseOfPending',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/School/CapitalApplicationForUseOfPending.vue'),
        meta: {
          title: '食堂资金管理-待处理资金申请',
          index: 2
        }
      },
      {
        path: 'CapitalAppropriationHistory',
        name: 'CapitalAppropriationHistory',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/School/CapitalAppropriationHistory.vue'),
        meta: {
          title: '食堂资金管理-资金拨付记录',
          index: 2
        }
      },
      {
        path: 'CapitalShiftToHistoryOfSchool',
        name: 'CapitalShiftToHistoryOfSchool',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/School/CapitalShiftToHistory.vue'),
        meta: {
          title: '食堂资金管理-资金转出记录',
          index: 2
        }
      },
      // 食堂资金管理：乡镇端：
      {
        path: 'CapitalApplicationAuditOfVillagesAndTowns',
        name: 'CapitalApplicationAuditOfVillagesAndTowns',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/VillagesAndTowns/CapitalApplicationAudit.vue'),
        meta: {
          title: '食堂资金管理-资金申请审核',
          index: 2
        }
      },
      {
        path: 'CapitalApplicationAuditHistoryOfVillagesAndTowns',
        name: 'CapitalApplicationAuditHistoryOfVillagesAndTowns',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/VillagesAndTowns/CapitalApplicationAuditHistory.vue'),
        meta: {
          title: '食堂资金管理-资金审核记录',
          index: 2
        }
      },
      // 食堂资金管理：县级端：
      {
        path: 'CapitalApplicationAuditOfCounty',
        name: 'CapitalApplicationAuditOfCounty',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/County/CapitalApplicationAudit.vue'),
        meta: {
          title: '食堂资金管理-资金申请审核',
          index: 2
        }
      },
      {
        path: 'CapitalApplicationAuditHistoryOfCounty',
        name: 'CapitalApplicationAuditHistoryOfCounty',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/County/CapitalApplicationAuditHistory.vue'),
        meta: {
          title: '食堂资金管理-资金审核记录',
          index: 2
        }
      },
      // 食堂资金管理：城投端：
      {
        path: 'CapitalApplicationAuditOfCityInvestment',
        name: 'CapitalApplicationAuditOfCityInvestment',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CityInvestment/CapitalApplicationAudit.vue'),
        meta: {
          title: '食堂资金管理-资金申请审核',
          index: 2
        }
      },
      {
        path: 'CapitalApplicationAuditHistoryOfCityInvestment',
        name: 'CapitalApplicationAuditHistoryOfCityInvestment',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CityInvestment/CapitalApplicationAuditHistory.vue'),
        meta: {
          title: '食堂资金管理-资金审核记录',
          index: 2
        }
      },
      {
        path: 'CapitalApplicationAuditForAppropriationOfCityInvestment',
        name: 'CapitalApplicationAuditForAppropriationOfCityInvestment',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CityInvestment/CapitalApplicationAuditForAppropriation.vue'),
        meta: {
          title: '食堂资金管理-资金拨付审核',
          index: 2
        }
      },
      {
        path: 'CapitalApplicationAuditHistoryForAppropriationOfCityInvestment',
        name: 'CapitalApplicationAuditHistoryForAppropriationOfCityInvestment',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CityInvestment/CapitalApplicationAuditHistoryForAppropriation.vue'),
        meta: {
          title: '食堂资金管理-资金拨付记录',
          index: 2
        }
      },
      {
        path: 'CapitalShiftToAuditOfCityInvestment',
        name: 'CapitalShiftToAuditOfCityInvestment',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CityInvestment/CapitalShiftToAudit.vue'),
        meta: {
          title: '食堂资金管理-资金转入审核',
          index: 2
        }
      },
      {
        path: 'CapitalShiftToAuditForAppropriationOfCityInvestment',
        name: 'CapitalShiftToAuditForAppropriationOfCityInvestment',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CityInvestment/CapitalShiftToAuditForAppropriation.vue'),
        meta: {
          title: '食堂资金管理-资金转入审核',
          index: 2
        }
      },
      {
        path: 'CapitalShiftToHistoryOfCityInvestment',
        name: 'CapitalShiftToHistoryOfCityInvestment',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CityInvestment/CapitalShiftToHistory.vue'),
        meta: {
          title: '食堂资金管理-资金转入记录',
          index: 2
        }
      },
      {
        path: 'CapitalShiftToHistoryForAppropriationOfCityInvestment',
        name: 'CapitalShiftToHistoryForAppropriationOfCityInvestment',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CityInvestment/CapitalShiftToHistoryForAppropriation.vue'),
        meta: {
          title: '食堂资金管理-资金转入记录',
          index: 2
        }
      },
      {
        path: 'CapitalShiftToHistoryDetail',
        name: 'CapitalShiftToHistoryDetail',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CapitalCommon/CapitalShiftToHistoryDetail.vue'),
        meta: {
          title: '食堂资金管理-资金转出登记表/转入确认表',
          index: 2
        }
      },
      {
        path: 'CapitalReceiptDetail',
        name: 'CapitalReceiptDetail',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CapitalCommon/CapitalReceiptDetail.vue'),
        meta: {
          title: '食堂资金管理-收据单',
          index: 2
        }
      },
      {
        path: 'CapitalOverview',
        name: 'CapitalOverview',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/CapitalCommon/CapitalOverview.vue'),
        meta: {
          title: '食堂资金管理-资金总览',
          index: 2
        }
      },
      {
        path: 'IncomeAndExpenses',
        name: 'IncomeAndExpenses',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenFinance/IncomeAndExpenses.vue'),
        meta: {
          title: '食堂财务管理-收支流水记录',
          index: 2
        }
      },
      {
        path: 'IncomeAndExpensesDetail',
        name: 'IncomeAndExpensesDetail',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenFinance/IncomeAndExpensesDetail.vue'),
        meta: {
          title: '食堂财务管理-收支流水记录',
          index: 2
        }
      },
      {
        path: 'AddOrUpdateIncomeAndExpenses',
        name: 'AddOrUpdateIncomeAndExpenses',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenFinance/AddOrUpdateIncomeAndExpenses.vue'),
        meta: {
          title: '食堂财务管理-收支流水记录',
          index: 2
        }
      },
      {
        path: 'Voucher',
        name: 'Voucher',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenFinance/Voucher.vue'),
        meta: {
          title: '食堂财务管理-凭证管理',
          index: 2
        }
      },
      {
        path: 'ReportForms',
        name: 'ReportForms',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenFinance/ReportForms.vue'),
        meta: {
          title: '食堂财务管理-报表管理',
          index: 2
        }
      },
      // 老的食堂库存管理：
      {
        path: 'CanteenInventory',
        name: 'CanteenInventory',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenInventory/CanteenInventory.vue'),
        meta: {
          title: '食堂库存管理',
          index: 2
        }
      },
      {
        path: 'AddOrUpdateCanteenInventory',
        name: 'AddOrUpdateCanteenInventory',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenInventory/AddOrUpdateCanteenInventory.vue'),
        meta: {
          title: '食堂库存管理-入库/出库',
          index: 2
        }
      },
      // 新的食堂库存管理：
      {
        path: 'InventoryOverview',
        name: 'InventoryOverview',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenInventory/InventoryOverview.vue'),
        meta: {
          title: '食堂库存管理-库存总览',
          index: 2
        }
      },
      {
        path: 'InventoryRecords',
        name: 'InventoryRecords',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenInventory/InventoryRecords.vue'),
        meta: {
          title: '食堂库存管理-库存记录',
          index: 2
        }
      },
      // {
      //   path: 'SunshineConsumption',
      //   name: 'SunshineConsumption',
      //   component: () =>
      //     import(/* webpackChunkName: "CanteenManagement" */ '@/views/SunshineConsumption/SunshineConsumption.vue'),
      //   meta: {
      //     title: '阳光消费管理',
      //     index: 2
      //   }
      // },
      // 食堂日常管理：
      {
        path: 'AccompanyMeal',
        name: 'AccompanyMeal',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/AccompanyMeal.vue'),
        meta: {
          title: '食堂日常管理-食品安全管理-陪餐管理',
          index: 2
        }
      },
      {
        path: 'AddOrUpdateAccompanyMeal',
        name: 'AddOrUpdateAccompanyMeal',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/AddOrUpdateAccompanyMeal.vue'),
        meta: {
          title: '食堂日常管理-食品安全管理-陪餐管理',
          index: 2
        }
      },
      {
        path: 'Purchase',
        name: 'Purchase',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/Purchase.vue'),
        meta: {
          title: '食堂日常管理-采购管理',
          index: 2
        }
      },
      {
        path: 'Train',
        name: 'Train',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/Train.vue'),
        meta: {
          title: '食堂日常管理-食品安全管理-培训管理',
          index: 2
        }
      },
      {
        path: 'AddOrUpdateTrain',
        name: 'AddOrUpdateTrain',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/AddOrUpdateTrain.vue'),
        meta: {
          title: '食堂日常管理-食品安全管理-培训管理',
          index: 2
        }
      },
      {
        path: 'RetainSpecimen',
        name: 'RetainSpecimen',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/RetainSpecimen.vue'),
        meta: {
          title: '食堂日常管理-食品安全管理-留样管理',
          index: 2
        }
      },
      {
        path: 'AddOrUpdateRetainSpecimen',
        name: 'AddOrUpdateRetainSpecimen',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/AddOrUpdateRetainSpecimen.vue'),
        meta: {
          title: '食堂日常管理-食品安全管理-留样管理',
          index: 2
        }
      },
      {
        path: 'Disinfect',
        name: 'Disinfect',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/Disinfect.vue'),
        meta: {
          title: '食堂日常管理-食品安全管理-消杀管理',
          index: 2
        }
      },
      {
        path: 'AddOrUpdateDisinfect',
        name: 'AddOrUpdateDisinfect',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/AddOrUpdateDisinfect.vue'),
        meta: {
          title: '食堂日常管理-食品安全管理-消杀管理',
          index: 2
        }
      },
      {
        path: 'Personnel',
        name: 'Personnel',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/Personnel.vue'),
        meta: {
          title: '食堂日常管理-人员管理',
          index: 2
        }
      },
      {
        path: 'AddOrUpdatePersonnel',
        name: 'AddOrUpdatePersonnel',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/AddOrUpdatePersonnel.vue'),
        meta: {
          title: '食堂日常管理-人员管理',
          index: 2
        }
      },
      {
        path: 'FoodSafety',
        name: 'FoodSafety',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenDayToDay/FoodSafety.vue'),
        meta: {
          title: '食堂日常管理-食品安全管理',
          index: 2
        }
      },
      // 食堂预警配置：
      {
        path: 'FoodPriceManagement',
        name: 'FoodPriceManagement',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/EarlyWarningConfig/FoodPriceManagement.vue'),
        meta: {
          title: '食堂预警配置-食材价格管理',
          index: 2
        }
      },
      {
        path: 'EarlyWarningConfig',
        name: 'EarlyWarningConfig',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/EarlyWarningConfig/EarlyWarningConfig.vue'),
        meta: {
          title: '食堂预警配置-预警项目配置',
          index: 2
        }
      },
      {
        path: 'AddOrUpdateEarlyWarning',
        name: 'AddOrUpdateEarlyWarning',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/EarlyWarningConfig/AddOrUpdateEarlyWarning.vue'),
        meta: {
          title: '食堂预警配置-预警项目配置',
          index: 2
        }
      },
      // 食堂巡查管理：
      {
        path: 'CostSupervise',
        name: 'CostSupervise',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/PatrolSupervise/CostSupervise.vue'),
        meta: {
          title: '食堂巡查监管-食堂成本监管',
          index: 2
        }
      },
      {
        path: 'DayToDaySupervise',
        name: 'DayToDaySupervise',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/PatrolSupervise/DayToDaySupervise.vue'),
        meta: {
          title: '食堂巡查监管-食堂日常巡查',
          index: 2
        }
      },
      {
        path: 'FinanceSupervise',
        name: 'FinanceSupervise',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/PatrolSupervise/FinanceSupervise.vue'),
        meta: {
          title: '食堂巡查监管-食堂财务巡查',
          index: 2
        }
      },
      {
        path: 'HistoryRecord',
        name: 'HistoryRecord',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/HistoryRecord/HistoryRecord.vue'),
        meta: {
          title: '历史档案管理',
          index: 2
        }
      },
      // {
      //   path: 'supplierBase',
      //   name: 'SupplierBase',
      //   component: () =>
      //     import(/* webpackChunkName: "CanteenManagement" */ '@/views/StapleCommodityReport/SupplierBase.vue'),
      //   meta: {
      //     title: '大宗商品报备-供应商库',
      //     index: 2
      //   }
      // },
      // {
      //   path: 'winTheBiddingSupplierBase',
      //   name: 'WinTheBiddingSupplierBase',
      //   component: () =>
      //     import(/* webpackChunkName: "CanteenManagement" */ '@/views/StapleCommodityReport/WinTheBiddingSupplierBase.vue'),
      //   meta: {
      //     title: '大宗商品报备-中标商库',
      //     index: 2
      //   }
      // },
      // {
      //   path: 'invoiceInformationReading',
      //   name: 'InvoiceInformationReading',
      //   component: () =>
      //     import(/* webpackChunkName: "CanteenManagement" */ '@/views/StapleCommodityReport/InvoiceInformationReading.vue'),
      //   meta: {
      //     title: '发票信息读取',
      //     index: 2
      //   }
      // },
      {
        path: 'SystemSetting',
        name: 'SystemSetting',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/SystemSetting/SystemSetting.vue'),
        meta: {
          title: '系统设置',
          index: 2
        }
      },
      {
        path: 'maintainSchoolInfoList',
        name: 'MaintainSchoolInfoList',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/CanteenCapital/MaintainSchoolInfo/MaintainSchoolInfoList.vue'),
        meta: {
          title: '学校信息维护',
          index: 2
        }
      },
      // 小程序收费设置：
      // miniProgramChargeSettingDhRJbRbH2451WEiSOoGE4Z0NpTy8?type=setting
      // miniProgramChargeSettingDhRJbRbH2451WEiSOoGE4Z0NpTy8?type=record
      {
        path: 'miniProgramChargeSettingDhRJbRbH2451WEiSOoGE4Z0NpTy8',
        name: 'MiniProgramChargeSettingDhRJbRbH2451WEiSOoGE4Z0NpTy8',
        component: () =>
          import(/* webpackChunkName: "CanteenManagement" */ '@/views/MiniProgramChargeSetting/index.vue'),
        meta: {
          title: '小程序收费设置',
          index: 2
        }
      },
    ],
    meta: {
      index: 2
    }
  },
  {
    path: '/404',
    name: '404',
    component: () =>
      import(/* webpackChunkName: "CanteenManagement" */ '@/views/404/404.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (store.state.User.token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (to.matched.length === 0) {
        next('/404')
      } else {
        next()
      }
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next({ path: '/login' })
    }
  }
})

export default router
